import React, { ReactElement, FunctionComponent } from 'react'
import BasicText, { BasicTextProps, WebHeadlineType } from '../BasicText'
import { TextColorTypes, TextAlignTypes } from '../FontTypes'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type Label10Props = WebHeadlineType &
    Pick<BasicTextProps, 'paddingLeft' | 'paddingRight' | 'paddingX' | 'paddingY'> & {
        children: string
        color?: TextColorTypes
        uppercase?: boolean
        textAlign?: TextAlignTypes
        lineHeight?: string
        bold?: boolean
        numberOfLines?: number
        onPress?: () => void
        allowFontScaling?: false
    } & TestID

const Label10Font: FunctionComponent<Label10Props> = ({
    children,
    color,
    textAlign,
    uppercase,
    bold,
    lineHeight = 'LH16',
    numberOfLines,
    onPress,
    testID,
    allowFontScaling,
    webHeadlineType,
    paddingLeft,
    paddingRight,
    paddingX,
    paddingY,
}): ReactElement => {
    return (
        <BasicText
            fontSize="FS10"
            lineHeight={lineHeight}
            {...{
                color,
                onPress,
                uppercase,
                textAlign,
                bold,
                numberOfLines,
                testID,
                allowFontScaling,
                webHeadlineType,
                paddingLeft,
                paddingRight,
                paddingX,
                paddingY,
            }}
        >
            {children}
        </BasicText>
    )
}

export default Label10Font
